const identityFn = <T>(value: T) => (value)

export default identityFn



// WEBPACK FOOTER //
// ./src/store/identity-fn.ts